export default "<div *ngFor=\"let component of components\">\n    <ng-template appTabContentHost></ng-template>\n</div>";